module.exports = __webpack_public_path__ + "static/media/product-8.a0e29a8d.png";